// Utils
import { isAnnotation, isColumn, isLine } from '../elements/utils/elementTypeUtils';

export const canBeAColumnChild = (el) => !isLine(el) && !isAnnotation(el) && !isColumn(el);
